// 003 (FR-009, FR-010; data-model §4): looks a code up once per code; `retry()` repeats it. Never
// retries on its own (a 429 must not be hammered). 004 reuses it after a reload of Add student.
// Each answer is kept with the request it belongs to, so a newer code or retry reads as loading
// until its own answer arrives (no state set synchronously in the effect).
import { useCallback, useEffect, useState } from "react";

import { useJoinClient } from "./joinApi";
import {
  type LookupResult,
  type LookupState,
  lookupSchool,
} from "./schoolLookup";

export function useSchoolLookup(code: string | null): {
  state: LookupState;
  retry: () => void;
} {
  const client = useJoinClient();
  const [attempt, setAttempt] = useState(0);
  const [answer, setAnswer] = useState<{
    key: string;
    result: LookupResult;
  } | null>(null);
  const key = `${code ?? ""}#${attempt}`;

  useEffect(() => {
    if (code === null) return;
    let live = true;
    void lookupSchool((c) => client.getSchoolByJoinCode(c), code).then(
      (result) => {
        if (live) setAnswer({ key, result });
      },
    );
    return () => {
      live = false;
    };
  }, [client, code, key]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);
  const state: LookupState =
    answer !== null && answer.key === key
      ? { status: "done", ...answer.result }
      : { status: "loading" };
  return { state, retry };
}
